export const appName = "Simplonline";
